var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from 'react';
import { WidgetEnvironmentContext } from './EnvironmentProvider';
export var withEnvironment = function (Component) {
    var Wrapped = function (props) {
        var environment = useContext(WidgetEnvironmentContext);
        if (!environment) {
            throw new Error("`withEnvironment` can't be used within a `Settings` component. Please use `withSettingsEnvironment()`");
        }
        return React.createElement(Component, __assign({}, __assign(__assign({}, props), { environment: environment })));
    };
    return Wrapped;
};
//# sourceMappingURL=withEnvironment.js.map